//Adapted from public library https://github.com/braintree/sanitize-url
const invalidProtocolRegex = /^([^\w]*)(javascript|data|vbscript)/im;
const htmlEntitiesRegex = /&#(\w+)(^\w|;)?/g;
const ctrlCharactersRegex =
  /[\u0000-\u001F\u007F-\u009F\u2000-\u200D\uFEFF]/gim;
const urlSchemeRegex = /^([^:]+):/gm;
const relativeFirstCharacters = [".", "/"];

function isRelativeUrlWithoutProtocol(url: string): boolean {
    return relativeFirstCharacters.indexOf(url[0]) > -1;
  }
  
function decodeHtmlCharacters(str: string) {
return str.replace(htmlEntitiesRegex, (match, dec) => {
    return String.fromCharCode(dec);
});
}
export default class Utils {
    static sanitizeUrl(url?: string): string {
        const sanitizedUrl = decodeHtmlCharacters(url || "")
          .replace(ctrlCharactersRegex, "")
          .trim();
      
        if (!sanitizedUrl) {
          return "";
        }
      
        if (isRelativeUrlWithoutProtocol(sanitizedUrl)) {
          return sanitizedUrl;
        }
      
        const urlSchemeParseResults = sanitizedUrl.match(urlSchemeRegex);
      
        if (!urlSchemeParseResults) {
          return sanitizedUrl;
        }
      
        const urlScheme = urlSchemeParseResults[0];
      
        if (invalidProtocolRegex.test(urlScheme)) {
          return "";
        }
      
        return sanitizedUrl;
      }
}